import Settings from './Settings.vue';
import MenuItem from './MenuItem.vue';

const routes = [
  {
    name: 'modules.payment_gateways',
    component: Settings,
    path: '/modules/payment_gateways',
  },
];

export default {
  menu_item: MenuItem,
  settings_component: Settings,
  routes,
};
